export default function triggerEvent(obj, name, detail) {
  const event = new CustomEvent(name, {
    bubbles: true,
    cancelable: true,
    detail,
  });
  obj.dispatchEvent(event);
  return !event.defaultPrevented;
}
